export type Clinic = {
  id: number;
  name: string;
  displayName: string;
  featureFlags?: string[];
};
